module.exports = __webpack_public_path__ + "static/media/submit.dc5191fd.svg";